export const EVENT_NUMBER_MENTION_TRIGGER = '#';

// group 0: event number with leading # ('#0830230001')
// group 1: #
// group 2: event number (without #)
// this is for a single event number match when type and search/autocomplete
export const EVENT_NUMBER_MENTION_REGEX = new RegExp(/(#)([\w]{3,})$/);

export const EVENT_NUMBER_MENTION_QUERY_MIN_LENGTH = 3;

export const EVENT_NUMBER_MENTION_QUERY_DEBOUNCE_MILLISECONDS = 250;

export enum MentionNodeType {
    EventNumber = 'event-number-mention',
}
